<template>
	<div :class="['input-comp', value.length > 0 ? 'active' : '']" v-if="heritedData">
		<label :class="['input-comp--label', value.length > 0 ? 'active' : '']">{{ heritedData.label }}</label>
		<label :class="['input-comp--placeholder', value.length > 0 ? 'active' : '', heritedData.type === 'textarea' ? 'input-comp--placeholder--text' : '']">{{ heritedData.label }}</label>

		<input type="email" v-model="value" :name="heritedData.name" v-if="heritedData.type === 'email'">
		<textarea :name="heritedData.name" v-model="value" v-if="heritedData.type === 'textarea'"></textarea>
	</div>
</template>

<script>
	export default {
		name: 'input-comp',
		props: ['heritedData'],
		data () {
			return {
				value: ''
			}
		},
		watch: {
			value () {
				this.$store.commit('setFormData', {
					key: this.heritedData.name,
					value: this.value
				})
			}
		}
	}
</script>

<style lang="scss">
	.input-comp {
		position: relative;

		&::after {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 1px;
			max-width: 0;
			background: $basic_black;
			content: '';
			@include transition(all .4s);
		}

		&.active::after {
			max-width: 100%;
		}

		label,
		input,
		textarea {
			display: block;
			font-family: $main_font;
			letter-spacing: 0.05em;
			@include fontSize(18);
		}

		.input-comp--label {
			opacity: 0;
			transform: translateX(-20px);
			@include fontSize(22);
			@include transition(all .4s);

			&.active {
				opacity: 1;
				transform: translateX(0);
				@include transition(all .4s .2s);
			}
		}

		.input-comp--placeholder {
			position: absolute;
			top: 37px;
			left: 0;
			pointer-events: none;
			color: $main_grey;
			@include transition(all .2s .2s);

			&--text {
				top: 32px;
			}

			&.active {
				opacity: 0;
				transform: translateX(-20px);
				@include transition(all .2s);
			}
		}

		input,
		textarea {
			width: 100%;
			height: 40px;
			outline: none;
			border: 0;
			border-bottom: 1px solid $main_grey;
		}

		textarea {
			height: 100px;
			padding-top: 5px;
			resize: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/ui/InputComp.vue?618d1f45